module.exports = __webpack_public_path__ + "static/media/photo5.545dd4ef.jpeg";